import { handleActions, combineActions } from 'redux-actions';
import { Map } from 'immutable';

import actions from '../actions';

//REDUCERS
const { params } = actions.customer;
export default handleActions(
  {
    [combineActions(params.createFromUrl.toString(), params.updateParams.toString())]: (params, { payload }) => {
      return payload;
    }
  },
  Map({
    url_params: null,
    params: Map()
  })
);
